import React, { useEffect, useState } from "react";
import Header from "../components/common/header";
import TabsComponent from "../components/Dashboard/TabsComponent";
import SearchComponent from "../components/Dashboard/SearchComponent";
import PaginationComponent from "../components/Dashboard/Pagination";
import Loader from "../components/common/Loader";
import BackToTop from "../components/common/BackToTop";
import { useCoinsContext } from "../context/CoinsContext";

function DashboardPage() {
  const { coins, loading, error } = useCoinsContext();
  const [search, setSearch] = useState("");
  const [paginatedCoins, setPaginatedCoins] = useState([]);
  const [page, setPage] = useState(1);

  const handleChange = (event, value) => {
    setPage(value);
    const previousIndex = (value - 1) * 10;
    setPaginatedCoins(coins.slice(previousIndex, previousIndex + 10));
  };

  const onSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const filteredCoins = coins.filter(
    (coin) =>
      coin.name.toLowerCase().includes(search.toLowerCase()) ||
      coin.symbol.toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    if (coins.length) {
      setPaginatedCoins(coins.slice(0, 10));
      setPage(1);
    }
  }, [coins]);

  return (
    <>
      <Header />
      <BackToTop />
      {loading ? (
        <Loader />
      ) : (
        <div>
          {error ? (
            <p
              style={{
                textAlign: "center",
                color: "var(--red)",
                margin: "1rem",
              }}
            >
              {error}
            </p>
          ) : null}
          <SearchComponent search={search} onSearchChange={onSearchChange} />
          <TabsComponent coins={search ? filteredCoins : paginatedCoins} />
          {search ? null : (
            <PaginationComponent
              page={page}
              handleChange={(event, value) => handleChange(event, value)}
            />
          )}
        </div>
      )}
    </>
  );
}

export default DashboardPage;
